import { nextTick, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useAnalytics } from '@/composables/useAnalytics'
import { useNotificationsPopoverStore } from '@/stores/useNotificationsPopoverStore'

// `?notifications=settings` on any authenticated route (the footer link in notification emails) opens the
// nav notifications popover on its settings pane and drops the query. PostHog flags resolve after first
// paint, so the open waits for the flag instead of reading it once.
export function useNotificationsSettingsDeepLink() {
    const route = useRoute()
    const router = useRouter()
    const { featureFlags } = useAnalytics()
    const notificationsPopover = useNotificationsPopoverStore()

    let stopWaiting = null

    function openSettingsWhenEnabled() {
        stopWaiting?.()
        stopWaiting = watch(
            () => featureFlags.signalWatchNotifications,
            (enabled) => {
                if (!enabled) return
                notificationsPopover.openSettings()
                nextTick(() => stopWaiting?.())
            },
            { immediate: true }
        )
    }

    watch(
        () => route.query.notifications,
        (value) => {
            if (value !== 'settings') return
            const query = { ...route.query }
            delete query.notifications
            router.replace({ query })
            openSettingsWhenEnabled()
        },
        { immediate: true }
    )
}
